import { theme as baseTheme } from '@chakra-ui/react';

export const colors = {
  primary: baseTheme.colors.blue,
  secondary: baseTheme.colors.teal,
  alert: baseTheme.colors.red,
  uiBorder: baseTheme.colors.blue[200],
  selected: baseTheme.colors.blue[400],
};
